<div
  (click)="clickCard.emit()"
  class="memo-list-card overflow-hidden mb-3 touch-card"
  [class.disabled]="disabled"
  [ngClass]="{ 'selected-card': isSelectedCard }"
>
  <div class="p-2 d-flex flex-column">
    <div class="box-mini-pdf">
      <div class="box" [style.height.px]="thumbnailHeight">
        <ng-container
          [ngTemplateOutlet]="
            cardThumbnail
              ? cardThumbnail.templateRef
              : defaultThumbnailTemp
          "
        ></ng-container>
        <ng-template #defaultThumbnailTemp>
          <img
            class="round-input"
            src="{{ thumbnail_img | secure | async }} "
          />
          @if (!thumbnail_img) {
            <div class="position-absolute round-input empty-bg"></div>
          }
          @if (isProtected) {
            <div class="position-absolute round-input bg-lock">
              <div class="icon-lock">
                <svg
                  stroke-width="2"
                  width="34"
                  height="40"
                  viewBox="0 0 34 40"
                >
                  <use
                    href="assets/images/icons/securities/shield-lock.svg#shield-lock"
                  ></use>
                </svg>
              </div>
            </div>
          }
        </ng-template>
      </div>
      @if (hasCheck) {
        <div
          (click)="$event.stopPropagation()"
          class="position-checkbox"
        >
          <div class="d-flex justify-content-end p-2">
            <input
              type="checkbox"
              class="form-control check checkbox-default default-size"
              [ngModel]="checked"
              (ngModelChange)="checkedChange.emit($event)"
              name="checked"
              [disabled]="isProtected"
            />
          </div>
        </div>
      }
    </div>
    <ng-container
      [ngTemplateOutlet]="cardDetail.templateRef"
    ></ng-container>
  </div>
</div>
